module.exports = __webpack_public_path__ + "static/media/group.b14f6d43.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/shifting/group.png
// module id = 126
// module chunks = 0